import React, { useEffect, useRef } from 'react';

interface TelegramCommentsProps {
  slug: string;
}

const SCRIPT_SRC = 'https://comments.app/js/widget.js?3';
const WEBSITE_ID = 'UkB3oY8z';

const TelegramComments: React.FC<TelegramCommentsProps> = ({ slug }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Limpa o container antes de injetar (evita duplicação ao trocar de post)
    container.innerHTML = '';

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.setAttribute('data-comments-app-website', WEBSITE_ID);
    script.setAttribute('data-limit', '5');
    script.setAttribute('data-page-id', slug);
    script.setAttribute('data-dark', '1');

    container.appendChild(script);

    // Cleanup: remove o script e qualquer iframe injetado pelo widget
    return () => {
      container.innerHTML = '';
    };
  }, [slug]);

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 mt-16 border-t border-slate-800 pt-8 pb-16">
      <h2 className="font-display text-2xl font-bold text-white mb-6">Comentários</h2>
      <div ref={containerRef} />
    </div>
  );
};

export default TelegramComments;

